<template>
  <div class="diy-shop">
  <div class="shop-item" v-for="(dataItem,index) in datalist" :key="index">
    <form @click="_onTargetDetail(dataItem.shop_id)" report-submit="true">
      <button formType="submit" class="btn-normal dis-flex flex-y-center" :data-id="dataItem.shop_id">
        <div class="shop-item__logo">
          <img :src="dataItem.logo_image">
        </div>
        <div class="shop-item__content flex-box">
          <div class="shop-item__title">
            <span>{{ dataItem.shop_name }}</span>
          </div>
          <div class="shop-item__address onelist-hidden">
            <span>门店地址：{{ dataItem.region.province }}{{ dataItem.region.city }}{{ dataItem.region.region }}{{ dataItem.address }}</span>
          </div>
          <div class="shop-item__phone">
            <span>联系电话：{{ dataItem.phone }}</span>
          </div>
        </div>
      </button>
    </form>
  </div>
</div>
</template>

<script>
// import { Swipe, SwipeItem } from 'vant';
// import Vue from "vue";
// Vue.use(Swipe).use(SwipeItem);
export default {
  props: ["itemIndex", "itemStyle", "datalist"],
  created(){
  },
  activated() {
  },
  methods:{
    _onTargetDetail(id) {
      // 记录formid
      this.$router.push({
        path:'/pages/shop/detail/index',
        query:{
          id:id
        }
      })
    }
  }
};
</script>

<style lang="less" scoped>
@import url("../../style/skin.less");
/* 线下门店 */

.shop-item {
  padding: 8px 15px;
  min-height: 90px;
  font-size: 13px;
  line-height: 1.5;
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
}

.shop-item__logo {
  margin-right: 15px;
}

.shop-item__logo img {
  display: block;
  width: 65px;
  height: 65px;
  border-radius: 50%;
  border: 1px solid rgba(0, 0, 0, 0.1);
  /* box-shadow: 0 0 30rpx rgba(0, 0, 0, 0.1); */
}

.shop-item__title {
  font-size: 14px;
  color: #fd4a5f;
  margin-bottom: 5px;
}

.shop-item__address, .shop-item__phone {
  color: #919396;
}

.shop-item__address {
  width: 260px;
}

.shop-item__distance {
  margin-top: 5px;
  color: #c1c1c1;
  height: 20px;
}

.shop-item__distance .iconfont {
  color: #81838e;
  margin-right: 3px;
}

</style>